import { Module } from 'vuex';
import { getters } from './getters';
import { ApplicationFormTemplateState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;
export const state: ApplicationFormTemplateState = {
    templates: undefined,
    templateCount: 0,
    simpleApplicationButtonHidden: false,
    templateDetails: {},
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    count: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

export const applicationFormTemplate: Module<ApplicationFormTemplateState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
